import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { BiCross } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";

const circles = [
  {
    id: 1,
    size: 360,
    title: "Intelligent Network",
    colorHex: "#1C1A66",
    delay: 4,
    offSet: "25%",
    top: 4,
  },
  {
    id: 2,
    size: 260,
    title: "Embedded Services",
    colorHex: "#3B3986",
    delay: 4.02,
    offSet: "25%",
    top: 2,
  },
  {
    id: 3,
    size: 180,
    title: "Cloud Software",
    colorHex: "#5B59A6",
    delay: 4.04,
    offSet: "25%",
    top: 0,
  },
  { id: 4, size: 100, title: "", colorHex: "#7c75a1ff", delay: 4.06, top: 2 },
];

const Booking = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [showHeading, setShowHeading] = useState(true);
  const [disableHover, setDisableHover] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [DetailId, setDetailId] = useState(null);
  const [extraDetails, setExtraDetails] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const xValues = isMobile
    ? [0, 0, 0, 0, 0, 0, 0, 0]
    : isTablet
    ? [-210, -210, -210, -210, -210, -210, -210, 0]
    : [-350, -350, -350, -350, -350, -350, -350, 0];

  const yValues = isMobile
    ? [0, 0, 0, 250, 250, 0, 0, 0]
    : isTablet
    ? [0, 0, 0, 500, 500, 0, 0, 0]
    : [0, 0, 0, 500, 500, 0, 0, 0];

  const sizeMultiplier = isMobile ? 0.6 : isTablet ? 0.8 : 1;

  const extraprops = {
    animate: {
      scale: [1, 13.2],
      y: [0, 0],
      x: isMobile ? [0, 0] : isTablet ? [0, -210] : [0, -350],
      opacity: [1, 1],
    },
    transition: {
      duration: 2,
      times: [0, 1],
      ease: "easeInOut",
    },
  };

  return (
    <div className="md:pt-20 min-h-screen w-screen flex items-center justify-center overflow-x-hidden relative">
      {extraDetails && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.6 }}
          className="absolute z-99 right-2 top-14 md:right-20 md:top-20"
        >
          <button
            className="inline-flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-neutral-950 cursor-pointer hover:rotate-45 transition duration-300"
            onClick={() => {
              setDisableHover(false);
              setExtraDetails(false);
            }}
          >
            <RxCross2 color="white" size={26} />
          </button>
        </motion.div>
      )}
      <motion.div className="relative w-full h-full flex items-center justify-between flex-col md:flex-row gap-10">
        <motion.div
          className="flex-1 items-center justify-between py-30 md:py-0 w-full px-2 md:px-0"
          animate={{
            x: isMobile
              ? 0
              : DetailId === 0
              ? isTablet
                ? "80%"
                : "80%"
              : "20%",
          }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          {DetailId === 0 && (
            <div className="cursor-pointer w-full px-0 flex items-start md:items-end flex-col">
              <motion.h2
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-3xl font-bold text-pink-500 mb-12 w-xl"
              >
                Optimize your quality program performance with insights and
                coaching
              </motion.h2>
              <div className="flex flex-col items-start md:items-end justify-start w-full gap-4">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between p-8 rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>
                    Reliable, secure, cloud-based offering updates automatically
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  whileTap={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between p-8 rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span className="w-xl">
                    Provides insights that empower your practice to improve
                    performance
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  whileTap={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between p-8 rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>
                    Automatically connects to the rest of the healthcare
                    ecosystem
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
              </div>
            </div>
          )}

          {DetailId === 1 && (
            <div className="cursor-pointer w-full ">
              <motion.h2
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-3xl font-bold text-pink-500 mb-4"
              >
                athenaOne's embedded, AI-powered service model helps you get
                paid what you're owed faster, with less work.
              </motion.h2>
              <div className="flex flex-col items-start justify-start w-full gap-4">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between p-8 rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>
                    Manages revenue cycle and removes administrative work
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  whileTap={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between p-8 rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>
                    Monitors practice performance and improves efficiency
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  whileTap={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between p-8 rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>
                    Assigns a dedicated customer success team to provide
                    actionable guidance
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
              </div>
            </div>
          )}

          {DetailId === 2 && (
            <div className="cursor-pointer w-full">
              <motion.h2
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-3xl font-bold text-pink-500 mb-4"
              >
                Manage every aspect of your practice with athenaOne's
                comprehensive, fully integrated, AI-powered software.
              </motion.h2>
              <div className="flex flex-col items-start justify-start w-full gap-8">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl p-6"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span className="w-full max-w-xl">
                    EHR with intuitive, configurable workflows
                  </span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  whileTap={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl p-6"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>Practice & revenue cycle management</span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                  whileTap={{ scale: 1.05, transition: { duration: 0.1 } }}
                  className="flex items-center justify-between rounded-lg bg-pink-200 cursor-pointer hover:bg-pink-300 w-full max-w-xl text-2xl p-6"
                  onClick={() => console.log("Clicked box:")}
                >
                  <span>Patient engagement</span>
                  <BsArrowRight className="text-pink-600" />
                </motion.div>
              </div>
            </div>
          )}

          {DetailId === 3 && (
            <div className="cursor-pointer w-full ">
              <motion.h2
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-5xl font-bold text-pink-500 mb-4"
              >
                The best solution for your practice
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-xl font-bold text-pink-500 mb-4"
              >
                Glow PCOD is an all-in-one solution that empowers your
                healthcare practice to deliver the best possible care and
                business outcomes. It combines user friendly AI-powered
                software, an embedded service model, and a connected network
                that surfaces the right patient information at the right time.
              </motion.p>
            </div>
          )}
        </motion.div>

        {showHeading && (
          <motion.h1
            animate={{
              scale: isMobile
                ? [1, 20, 50]
                : isTablet
                ? [1, 20, 37]
                : [1, 20, 37],
              x: isMobile
                ? [0, "-580%", "-1400%"]
                : isTablet
                ? [0, "-550%", "-1050%"]
                : [0, "-550%", "-1050%"],
              opacity: [1, 1, 0],
            }}
            transition={{
              duration: 2,
              times: [0, 0.8, 1],
              ease: "linear",
              delay: 1.5,
            }}
            initial={{ y: 50, opacity: 0 }}
            className="font-sans text-5xl sm:text-lg md:text-8xl"
            onAnimationComplete={() => setShowHeading(false)}
          >
            <span>Glow</span> <span>PCOD</span>
          </motion.h1>
        )}
        <motion.div
          animate={{
            x: isMobile
              ? 0
              : DetailId === 0
              ? isTablet
                ? "-100%"
                : "-100%"
              : 0,
          }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="relative flex-1 items-center justify-center"
        >
          <motion.div
            className="relative flex-1 items-center justify-center"
            {...(extraDetails
              ? extraprops
              : {
                  animate: { scale: 1, x: 0, y: 0 },
                  transition: { duration: 0.8 },
                })}
            // onAnimationStart={() => setDisableHover(true)}
            onAnimationEnd={() => setDisableHover(false)}
            onHoverStart={() =>
              !extraDetails && !disableHover && setIsHovered(true)
            }
            onHoverEnd={() => setIsHovered(false)}
          >
            {circles.map((circle, i) => {
              return (
                <motion.div
                  key={i}
                  animate={{
                    scale: [16, 4, 4, 3.5, 3.5, 3, 1, 1],
                    y: yValues,
                    x: xValues,
                    opacity: [0, 1, 1, 1, 1, 1, 1, 1],
                  }}
                  transition={{
                    duration: 7,
                    times: [0, 0.1, 0.15, 0.3, 0.45, 0.7, 0.9, 1],
                    ease: "easeInOut",
                    delay: circle.delay,
                  }}
                  onAnimationComplete={() => {
                    setDetailId(3);
                    setDisableHover(false);
                  }}
                  className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-full"
                >
                  <motion.div
                    animate={{
                      scale: isHovered ? 1.2 : 1,
                      backgroundColor:
                        DetailId === i ? "#DB2777" : circle.colorHex,
                    }}
                    transition={{
                      scale: { type: "spring", stiffness: 200, damping: 15 },
                      backgroundColor: { duration: 0.6, ease: "easeInOut" },
                    }}
                    className={`rounded-full ${
                      !disableHover && "shadow-class cursor-pointer"
                    }`}
                    onTap={() =>
                      !extraDetails && !disableHover && setDetailId(i)
                    }
                    onClick={() =>
                      !extraDetails && !disableHover && setDetailId(i)
                    }
                  >
                    <motion.div
                      className="rounded-full"
                      style={{
                        width: circle.size * sizeMultiplier,
                        height: circle.size * sizeMultiplier,
                      }}
                      transition={{ duration: 0.3 }}
                    />

                    <svg
                      className="absolute w-full h-full"
                      style={{ bottom: `${circle.top}px` }}
                      viewBox="0 0 200 200"
                    >
                      <defs>
                        <path
                          id={`circlePath-${i}`}
                          d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                        />
                      </defs>
                      <text fill="white" fontSize="12">
                        <textPath
                          href={`#circlePath-${i}`}
                          startOffset={circle?.offSet}
                          textAnchor="middle"
                        >
                          {circle.title}
                        </textPath>
                      </text>
                    </svg>
                  </motion.div>
                </motion.div>
              );
            })}
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Booking;
